import gql from 'graphql-tag';

export const GET_ATTRACTION_BY_ID = gql`
  query attractions_by_pk($id: uuid!) {
    attractions_by_pk(id: $id) {
      id
      name
      description
      open_hours
      type_of_attraction
      image_url
      location
      location_text
      created_at
      updated_at
      council_attraction_galleries(limit: 2, order_by: { created_at: desc }) {
        id
        image_url
        image_path
        comment
        created_at
        updated_at
      }
    }
  }
`;
